import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFCore/components/typography";

import css from "./side_info.module.scss";

type SideInfoProps = {
  label: string;
  value: string;
  tooltipContent?: string;
};

export const SideInfo = ({ label, value, tooltipContent }: SideInfoProps) => (
  <aside className={css.aside}>
    <Typography variant="labelRegular" clipOverflow>
      {label}
    </Typography>
    <Tooltip content={tooltipContent} triggerContainerProps={{ className: css.fitContent }}>
      <Typography variant="bodyBold" clipOverflow>
        {value}
      </Typography>
    </Tooltip>
  </aside>
);
